function getShortDate(date) {
    return getMonthName(date) + " " + date.getDate() + ", " + date.getFullYear();
}

function getShortHour(date) {
    return date.getHours() + ":" + ((date.getMinutes() < 10) ? "0" + date.getMinutes() : date.getMinutes());
}

function getCompoundDate(date, options = { boldDate: false, boldHour: false }) {
    let dateString = (options.boldDate) ? ("<b>" + getShortDate(date) + "</b>") : getShortDate(date);
    let hourString = (options.boldHour) ? ("<b>" + getShortHour(date) + "</b>") : getShortHour(date);

    return dateString + " a las " + hourString;
}

function getMonthName(date, shortName = true) {
    switch (date.getMonth()) {
        case 0:
            return (shortName) ? "ene" : "enero";
        case 1:
            return (shortName) ? "feb" : "febrero";
        case 2:
            return (shortName) ? "mar" : "marzo";
        case 3:
            return (shortName) ? "abr" : "abril";
        case 4:
            return (shortName) ? "may" : "mayo";
        case 5:
            return (shortName) ? "jun" : "junio";
        case 6:
            return (shortName) ? "jul" : "julio";
        case 7:
            return (shortName) ? "ago" : "agosto";
        case 8:
            return (shortName) ? "sep" : "septiembre";
        case 9:
            return (shortName) ? "oct" : "octubre";
        case 10:
            return (shortName) ? "nov" : "noviembre";
        case 11:
            return (shortName) ? "dic" : "diciembre";
        default:
            return ""
    }
}

function getDayOfTheWeekName(date) {
    switch (date.getDay()) {
        case 0:
            return "domingo";
        case 1:
            return "lunes";
        case 2:
            return "martes";
        case 3:
            return "miércoles";
        case 4:
            return "jueves";
        case 5:
            return "viernes";
        case 6:
            return "sábado";
        default:
            return "";
    }
}

function getDatesInterval(startDate, finalDate, boldMinutes = true) {
    let secondsOff = (finalDate - startDate) / 1000;

    let daysOff = Math.floor(secondsOff / 60 / 60 / 24);
    let hoursOff = Math.floor(secondsOff / 60 / 60 - daysOff * 24);
    let minutesOff = Math.ceil(secondsOff / 60 - hoursOff * 60 - daysOff * 24 * 60);

    return ((daysOff > 0) ? (daysOff > 1) ? daysOff + " días, " : daysOff + " día, " : "") +
        ((hoursOff > 0) ? (hoursOff > 1) ? hoursOff + " horas, " : hoursOff + " hora, " : "") +
        ((boldMinutes) ? "<b>" : "") + minutesOff + " " + ((minutesOff > 1) ? "minutos" : "minuto") + ((boldMinutes) ? "</b > " : "");
}


module.exports = {
    getShortHour,
    getShortDate,
    getMonthName,
    getCompoundDate,
    getDatesInterval,
    getDayOfTheWeekName
}